import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlLogin = `${webUrlBase}api/authenticate`
export const urlUpdateUserName = `${webUrlBase}api/mobile/users/update_user_name`
export const urlUpdatePhoneNumber = `${webUrlBase}api/mobile/users/update_user_phone`
export const urlUpdateDeviceData = `${webUrlBase}api/mobile/users/update_device`
export const urlGetUserClient = `${webUrlBase}api/mobile/users/get_client_user`
